// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-heading-form[data-v-14ad6e12]{display:inline-block;font-size:1rem;font-weight:bold;position:relative;margin-bottom:8px}.m-heading-form-label[data-v-14ad6e12]{background:#fff;font-size:1rem;color:#fff;padding:2px 4px;margin-left:8px}.m-heading-form-label.is-required[data-v-14ad6e12]{background:#ff4050}.m-heading-form-label.is-any[data-v-14ad6e12]{background:#707070}", ""]);
// Exports
module.exports = exports;
